export enum TYPES {
  SET_PRODUCT = 'setProduct',
  SET_VARIANT = 'setVariant',
}
